// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"1a8cfa8f","331":"c44d5feb","483":"337033c0","825":"fd1fae43","881":"82a36387"}[chunkId] + ".chunk.js";
};